import './app.less';

$(function () {
  try {
    spm.push({"category":"1","action":"open"});
  } catch (e) {
    console.error("首页打点");
  }

  function playVideo(index) {
    $('.video-wrapper').css({
        display: 'block'
    })

    let left, top, $video, $entrance;

    $('.click-area').css({
        display: 'block'
    });
    left = '6.8rem';
    top = '14rem';
    $video = $('#video1');
    $video.removeClass("hidden");
    $entrance = $('.entrance');
    $video[0].play();


    $video[0].playbackRate = 1;
    $('.videoMask').css({display: 'block'});

    $video[0].onended = function() {
      $entrance.animate({
          "left": left,
          "top": top,
          "opacity": 1
        }, 500, function () {
          $entrance.addClass('entrance-active');
          $('.click-area').on('click', function(){
            $entrance.css({ opacity: 0});
            try {
              spm.push({"category":"2","action":"play","value": `${index}`});
            } catch (e) {
              console.error("视频播放打点");
            }
            window.location.href='//p.xinwen.cn/act/list2018h5';
          })
        });
    }
  }

  $('.video-play').on('click', function(){
  	try {
      spm.push({"category":"1","action":"play","value": '1'});
    } catch (e) {
      console.error("视频播放打点");
    }
    playVideo(1);
    $(this).css({display: 'none'});
  })
})

// 微信分享配置
if (window.wx) {
	function monitor(category, action, label, value, nodeid) {
		window._czc && _czc.push(["_trackEvent", category, action, label, value, nodeid]);
	}

  function shared(category,action,value) {
    try {
      spm.push({"category":category,"action":action,"value":value});
    } catch (e) {
      console.error("分享打点错误");
    }
  }

	$.ajax({
		type: "GET",
		url: "//p.xinwen.cn/api/wechat/sign?url=" + encodeURIComponent(location.href.split('#')[0]),
		dataType: "json",
		success: function (res) {
			if (!res) {
				return false;
			}
			wx.config({
				appId: res.appid, // 必填，公众号的唯一标识
				timestamp: res.timestamp, // 必填，生成签名的时间戳
				nonceStr: res.nonceStr, // 必填，生成签名的随机串
				signature: res.signature, // 必填，签名，见附录1
				jsApiList: [
					'onMenuShareTimeline',
					'onMenuShareAppMessage',
					'onMenuShareQQ',
					'onMenuShareWeibo',
					'onMenuShareQZone',
					'getNetworkType'
				]
			});
		}
	})
	wx.ready(function () {
		var title = "确认过眼神，遇到对的世界杯打开方式！";
		var desc = "Magic@世界杯出品";
    var defaultImg = 'https://s.newscdn.cn/file/2018/06/a0107cc4-3f61-4140-9bc9-308d0d104e4e.png';
    var link = "https://p.xinwen.cn/act/worldcupc.html";
		var share = {
			title: title,
			desc: desc,
			link: link,
			imgUrl: defaultImg
		};
		wx.onMenuShareTimeline({
			title: share.title, // 分享标题
			link: share.link, // 分享链接
			imgUrl: share.imgUrl, // 分享图标
			success: function () {
				// 用户确认分享后执行的回调函数
				shared('3','share')
				monitor('share', 'timeline')
			},
			cancel: function () {
				// 用户取消分享后执行的回调函数
				shared('3','cancel')
				monitor('share', 'cancel', 'timeline')
			}
		})
		wx.onMenuShareAppMessage({
			title: share.title,
			desc: share.desc,
			link: share.link,
			imgUrl: share.imgUrl,
			success: function () {
        shared('3','share','message')
				monitor('share', 'message')
			},
			cancel: function () {
        shared('3','cancel','message')
				monitor('share', 'cancel', 'message')
			}
		})
		wx.onMenuShareQQ({
			title: share.title,
			desc: share.desc,
			link: share.link,
			imgUrl: share.imgUrl,
			success: function () {
        shared('3','share','qq')
				monitor('share', 'qq')
			},
			cancel: function () {
        shared('3','cancle','qq')
				monitor('share', 'cancel', 'qq')
			}
		})
		wx.onMenuShareWeibo({
			title: share.title,
			desc: share.desc,
			link: share.link,
			imgUrl: share.imgUrl,
			success: function () {
        shared('3','weibo','qq')
				monitor('share', 'weibo')
			},
			cancel: function () {
        shared('3','cancel','qq')
				monitor('share', 'cancel', 'weibo')
			}
		})
	})
	wx.error(function (res) {
    shared('3','error')
		monitor('wx', 'error')
	})
}



// WEBPACK FOOTER //
// ./src/pages/example/app.js